function RequiredStar({ customStyles }) {
  return <span style={{ fontSize: 22, ...customStyles }}>*</span>;
}

export default RequiredStar;
